import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
let inflight = null;

// Real platform count comes from the backend, never hard-coded.
export function usePlatforms() {
  const [data, setData] = useState(cache);
  useEffect(() => {
    if (cache) return;
    inflight = inflight || api.get("/platforms").then((r) => { cache = r.data; return cache; }).catch(() => null);
    let alive = true;
    inflight.then((d) => { if (alive && d) setData(d); });
    return () => { alive = false; };
  }, []);
  return data;
}
